import apiServices from '@/shared/services/api/axios'
import { IPayloadCreateInquiryGuest, IPayloadId } from '../../../shared/@types'

const InquiryGuestService = {
    apiCreateInquiry(payload: IPayloadCreateInquiryGuest) {
        return apiServices.post(`/create-inquiry`, payload)
    }
}
export default InquiryGuestService
